module.exports = __webpack_public_path__ + "static/media/ALIPER.32c54bd1.svg";